import { render, staticRenderFns } from "./atom-container-dumb.vue?vue&type=template&id=37246127&"
import script from "./atom-container-dumb.vue?vue&type=script&lang=js&"
export * from "./atom-container-dumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports